export const PaymentStatusEnum = Object.freeze({
    PROCESSED: "PROCESSED",
    FUTURE: "FUTURE",
    DELAYED: "DELAYED",
});
